import { zodResolver } from '@hookform/resolvers/zod'
import { Controller, FormProvider, useForm } from 'react-hook-form'

import { Button } from '@/components/ui/button'
import { Dialog } from '@/components/ui/dialog'
import { RangeSlider } from '@/components/ui/range-slider/RangeSlider.tsx'
import type { StatisticsFiltersForm } from '@/dialogs/StatisticsSoundsFiltersDialog/validations.ts'
import {
  defaultValuesStatisticsFiltersForm,
  statisticsFilterSchema,
} from '@/dialogs/StatisticsSoundsFiltersDialog/validations.ts'
import type { DialogProps } from '@/dialogs/types'
import {
  VIDEO_VIEWS_MAX_RANGE,
  VIDEO_VIEWS_MIN_RANGE,
  VIDEO_VIEWS_SLIDER_STEP,
} from '@/modules/tiktok-research/consts'

interface Props extends DialogProps {
  onSubmit: (values: StatisticsFiltersForm) => void
  initialValues?: StatisticsFiltersForm
}

export const StatisticsSoundsFiltersDialog = ({
  isOpen,
  onClose,
  onSubmit,
  initialValues,
}: Props) => {
  const form = useForm<StatisticsFiltersForm>({
    resolver: zodResolver(statisticsFilterSchema),
    defaultValues: initialValues ?? defaultValuesStatisticsFiltersForm,
  })

  const handleSubmit = form.handleSubmit((values) => {
    onSubmit(values)
    onClose()
  })

  return (
    <Dialog
      show={isOpen}
      onClose={onClose}
      bigDialog
    >
      <FormProvider {...form}>
        <form onSubmit={handleSubmit}>
          <Dialog.Header className="mb-6">
            <Dialog.Title>Statistics Filter</Dialog.Title>
          </Dialog.Header>
          <Dialog.Description>
            <Controller
              name="postedVideos"
              control={form.control}
              render={({ field: { value, onChange } }) => (
                <RangeSlider
                  min={VIDEO_VIEWS_MIN_RANGE}
                  max={VIDEO_VIEWS_MAX_RANGE}
                  step={VIDEO_VIEWS_SLIDER_STEP}
                  value={value}
                  onValueChange={onChange}
                  label="Videos posted to the Sound"
                />
              )}
            />
          </Dialog.Description>
          <Dialog.ClosableFooter onClose={onClose}>
            <Button
              type="submit"
              variant="default"
              className="w-full"
            >
              Save
            </Button>
          </Dialog.ClosableFooter>
        </form>
      </FormProvider>
    </Dialog>
  )
}
